import { NavLink } from "react-router-dom";
import {
  LayoutGrid,
  Users,
  FolderKanban,
  BookOpen,
  Settings,
} from "lucide-react";
import NativStatePulse from "../../assets/images/NativStatePulse.svg";

const navItems = [{ label: "Dashboard", icon: LayoutGrid, path: "/dashboard" }];

const pageItems = [
  { label: "Users", icon: Users, path: "/users", badge: 3 },
  { label: "Projects", icon: FolderKanban, path: "/projects" },
  { label: "Library Management", icon: BookOpen, path: "/library" },
];

const settingsItem = [{ label: "Settings", icon: Settings, path: "/settings" }];

const Sidebar = () => {
  const linkClasses = ({ isActive }: { isActive: boolean }) =>
    `flex items-center justify-between px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
      isActive ? "bg-gray-100 text-gray-900" : "text-gray-600 hover:bg-gray-50"
    }`;

  return (
    <aside className="w-64 h-screen flex flex-col flex-shrink-0 bg-ns-app border-r border-ns-app-border">
      <div className="px-4 py-6">
        <img
          src={NativStatePulse}
          alt="NativState Pulse"
          className="h-18 mb-[-18px]"
        />
      </div>
      <div className="border-t border-ns-app-border" />

      <div className="flex-1 flex flex-col px-4 py-6 overflow-y-auto">
        <nav className="space-y-1">
          {navItems.map((item) => (
            <NavLink key={item.path} to={item.path} className={linkClasses}>
              <span className="flex items-center gap-2">
                <item.icon size={18} />
                {item.label}
              </span>
            </NavLink>
          ))}
        </nav>

        <p className="text-xs font-medium text-gray-400 mt-6 mb-2 px-3">
          Pages
        </p>
        <nav className="space-y-1">
          {pageItems.map((item) => (
            <NavLink key={item.path} to={item.path} className={linkClasses}>
              <span className="flex items-center gap-2">
                <item.icon size={18} />
                {item.label}
              </span>
              {item.badge && (
                <span className="text-xs bg-gray-100 text-gray-600 rounded-full px-2 py-0.5">
                  {item.badge}
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="mt-auto">
          <p className="text-xs font-medium text-gray-400 mb-2 px-3">Other</p>
          <nav className="space-y-1">
            {settingsItem.map((item) => (
              <NavLink key={item.path} to={item.path} className={linkClasses}>
                <span className="flex items-center gap-2">
                  <item.icon size={18} />
                  {item.label}
                </span>
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
